import { Injectable } from '@angular/core';
import {
  HubConnection,
  HubConnectionBuilder,
  LogLevel,
} from '@microsoft/signalr';
import { environment } from '../../../../environments/environment.dev';

@Injectable({
  providedIn: 'root',
})
export class SignalRService {
  private hubConnection: HubConnection | null = null;
  private hubUrl: string = '';

  constructor() {}

  connect(url: string) {
    this.hubUrl = url;
    this.hubConnection = new HubConnectionBuilder()
      .withUrl(this.hubUrl, {
        logger: environment.production ? LogLevel.Critical : LogLevel.Trace,
      })
      .withAutomaticReconnect()
      .build();

    this.startConnection().catch((err) =>
      console.error('Error while starting SignalR connection:', err)
    );
  }

  private async startConnection() {
    if (this.hubConnection) {
      try {
        await this.hubConnection.start();
        console.log('SignalR connection established successfully.');
      } catch (error) {
        console.error('Error establishing SignalR connection:', error);
        setTimeout(() => this.startConnection(), 5000);
      }
    }
  }

  disconnect() {
    if (this.hubConnection) {
      this.hubConnection
        .stop()
        .then(() => {
          console.log('SignalR connection stopped.');
          this.hubConnection = null;
        })
        .catch((err) =>
          console.error('Error while stopping SignalR connection:', err)
        );
    }
  }

  on(eventName: string, callback: (...args: any[]) => void) {
    if (this.hubConnection) {
      this.hubConnection.on(eventName, callback);
    }
  }

  off(eventName: string) {
    if (this.hubConnection) {
      this.hubConnection.off(eventName);
    }
  }
}
